module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "klickbox-edit-title"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.button_text')))]), _vm._v(" "), (!_vm.step.redirect_automatic) ? _c('input', {
    staticClass: "btn",
    staticStyle: {
      "padding-top": "25px",
      "margin-top": "-20px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.step.redirect_button_text
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateRedirectButtonText({
          event: $event,
          id: _vm.step.id
        })
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-8c9cd7e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/kind/Redirect.vue
 ** module id = 884
 ** module chunks = 1
 **/